(() => {
  class UserHistoryController {
    constructor($scope, Users, $rootScope) {
      'ngInject';

      Object.assign(this, {
        Users,
        $scope,
        $rootScope,
        pagination: {},
        timezone: $rootScope.timezones[0].timezone
      });
    }

    $onInit() {
      this.search();
    }

    timezoneChanged() {
      this.pagination.offset = 0;
      this.search();
    }

    search() {
      this.loading = true;
      this.Users.getHistory(this.user.id, this.pagination).then(({
        data
      }) => {
        // we commented this temporary code
        // because we don't need to do this anymore
        // now we are using the filter "paid = true"
        // var visitsFiltered = [];
        // data.data.forEach((visit) => {
        //   if (visit.admin_status === 9.9) {
        //     if (visit.paid) {
        //       visitsFiltered.push(visit);
        //     }
        //   } else {
        //     visitsFiltered.push(visit);
        //   }
        // });
        // this.orders = visitsFiltered;
        this.orders = data.data;
        Object.assign(this.pagination, data.pagination);
      }).catch(err => {
        console.error(err);
      }).finally(() => {
        this.loading = false;
      });
    }

  }

  UserHistoryController.$inject = ["$scope", "Users", "$rootScope"];
  angular.module('pims').component('userHistory', {
    bindings: {
      user: '<'
    },
    templateUrl: 'app/views/users/detail/tabs/history/user-history.tab.html',
    controller: UserHistoryController,
    controllerAs: 'history'
  });
})();